import { combineReducers } from 'redux';

import * as actionTypes from 'modules/bodyScan/actionTypes';

import data from 'modules/bodyScan/reducers/data';
import simpleSearchReducer from 'modules/global/reducers/simpleSearchReducer';

import { IMPORT_AUDITS_OR_TSCANS_SUCCESS } from 'modules/interventions/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

export default combineReducers({
  data,
  search: simpleSearchReducer(actionTypes.SEARCH_BODY_SCANS_REQUEST, {
    global: {
      paginationSlice: true,
      matcher: ({ meta }) => meta.source === 'modal',
    },
    ids: {
      [actionTypes.OPEN_BODY_SCANS_IMPORT_MODAL]: () => [],
    },
  }),
  open: createReducer(false, {
    [actionTypes.OPEN_BODY_SCANS_IMPORT_MODAL]: () => true,
    [actionTypes.CLOSE_BODY_SCANS_IMPORT_MODAL]: () => false,
    [IMPORT_AUDITS_OR_TSCANS_SUCCESS]: () => false,
  })
});
